import { render, staticRenderFns } from "./AdvanceProducer.vue?vue&type=template&id=f4b6edcc&scoped=true"
import script from "./AdvanceProducer.vue?vue&type=script&lang=js"
export * from "./AdvanceProducer.vue?vue&type=script&lang=js"
import style0 from "./AdvanceProducer.vue?vue&type=style&index=0&id=f4b6edcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b6edcc",
  null
  
)

export default component.exports